export const de = {
  app: {
    title: 'Cyber-Vault Extraction',
    tagline: 'Neon. Daten. Beute.',
  },
  title: {
    startRun: 'Terminal betreten',
    newRunner: 'Neuer Runner',
    continueRunner: 'Runner fortsetzen',
    placeholderName: 'Runner-Name',
    create: 'Erstellen',
    cancel: 'Abbrechen',
  },
  hud: {
    credits: 'Credits',
    premium: 'Quantum',
    cleanCode: 'Clean Code',
    corruptedData: 'Corrupted Data',
    neonGems: 'Neon Gems',
    heat: 'Heat',
    level: 'Level',
    xp: 'XP',
  },
  settings: {
    title: 'Einstellungen',
    language: 'Sprache',
    actions: 'Aktionen',
  },
  nav: {
    hero: 'Held',
    terminal: 'Terminal',
    dungeon: 'Dungeon',
    fight: 'Fight',
    market: 'Markt',
    feedback: 'Ideen',
    leaderboard: 'Rangliste',
    // legacy keys retained for any leftover refs (will be cleaned)
    home: 'Held',
    inventory: 'Inventar',
    character: 'Held',
  },
  home: {
    welcomeBack: 'Willkommen zurück,',
    dailyBriefing: 'Tages-Briefing',
    quickActions: 'Schnellaktionen',
    startSiphoning: 'Siphoning starten',
    viewInventory: 'Beute ansehen',
    openMarket: 'Markt öffnen',
    enterDungeon: 'Dungeon betreten',
    stats: 'Statistik',
    yieldPerMin: 'Ertrag / Min',
    activeBoosts: 'Aktive Boosts',
    noBoosts: 'Keine aktiven Boosts',
    noVaults: 'Starte das Terminal, um Energie zu sammeln, oder betritt einen Dungeon.',
    offlineEarnings: 'Offline-Ertrag',
    offlineEarned: 'Während du weg warst hast du verdient',
  },
  terminal: {
    back: 'Zurück',
    headline: 'Energy Siphon',
    siphonButton: 'SIPHON',
    charge: 'Ladung',
    lastDrop: 'Letzter Drop',
    nothing: 'Nichts',
    tapToSiphon: 'Tippe auf den Core — aktiv: 3× Credits, Idle läuft parallel.',
    shop: 'Auto-Miner Shop',
    yield: 'Passiver Ertrag',
    owned: 'besessen',
    lockedLevel: 'Lv {level} benötigt',
    buy: 'Kaufen',
    insufficient: 'Ressourcen fehlen',
  },
  inventory: {
    headline: 'Runner-Inventar',
    resources: 'Ressourcen',
    equipment: 'Ausrüstung',
    empty: 'Inventar leer. Siphoning starten oder einen Vault ausräumen.',
    slotsUsed: 'Slots',
    rarity: {
      common: 'Gewöhnlich',
      uncommon: 'Selten',
      rare: 'Rar',
      epic: 'Episch',
      legendary: 'Legendär',
      mythic: 'Mythisch',
    },
    value: 'Wert',
    equipped: 'Angelegt',
    salvage: 'Zerlegen',
    salvageConfirm: 'Wirklich zerlegen? Du erhältst Scrap + Credits zurück.',
  },
  market: {
    headline: 'Nano-Markt',
    comingSoon: 'Marktplatz offline',
    description:
      'Runner können bald Module handeln, Live-Preise einsehen und Echtzeit-Bestenlisten verfolgen. Bis dahin: Credits sammeln.',
  },
  dungeon: {
    headline: 'Data-Vaults',
    selectVault: 'Vault auswählen',
    startRun: 'Run starten',
    levelRequired: 'Level erforderlich',
    waves: 'Wellen',
    wave: 'Welle',
    flee: 'Vault verlassen',
    special: 'OVERRIDE',
    specialReady: 'OVERRIDE BEREIT',
    specialCharging: 'Aufladen',
    victory: 'VAULT GECLEART',
    defeat: 'RUNNER GEFALLEN',
    loot: 'Beute',
    xpGained: 'XP erhalten',
    creditsGained: 'Credits erhalten',
    corruptedDataGained: 'Corrupted Data gesichert',
    claimLoot: 'Beute einstecken',
    retry: 'Nochmal versuchen',
    backToVaults: 'Zurück zu Vaults',
    locked: 'Gesperrt',
    requirement: {
      level: 'Level',
      attack: 'ATK',
      defense: 'DEF',
      health: 'HP',
      slot: 'Slot',
      rarity: 'Rarity',
      weapon: 'Waffe angelegt',
      helmet: 'Helm angelegt',
      armor: 'Rüstung angelegt',
      accessory: 'Accessoire angelegt',
      shield: 'Schild angelegt',
      belt: 'Gürtel angelegt',
      sash: 'Schärpe angelegt',
      shoulder: 'Schultern angelegt',
    },
    tier: 'Tier',
    autoFarm: '🤖 Auto',
    autoFarmOn: '🤖 Auto AN',
    autoFarmOff: '🤖 Auto AUS',
    autoFarmInterval: 'alle {interval}',
    autoFarmLocked: 'Erst Vault clearen',
    useBoost: 'Boost einsetzen',
    boostsActive: 'Aktive Boosts',
    vaults: {
      vault_alpha: 'Outpost Alpha',
      vault_alpha_desc: 'Verlassener Außenposten. Tier 1. Security Bots und Drohnen patrouillieren.',
      vault_sigma: 'Lab Sigma',
      vault_sigma_desc: 'Gesicherter Forschungsflügel. Tier 2. Nur Runner mit Waffe.',
      vault_tau: 'Archive Tau',
      vault_tau_desc: 'Datenarchiv. Tier 3. Hohe ATK erforderlich.',
      vault_phi: 'Bunker Phi',
      vault_phi_desc: 'Militärbunker. Tier 4. Nur gepanzerte Runner überleben.',
      vault_omega: 'Nexus Omega',
      vault_omega_desc: 'Endgame. Tier 5. Voll-Epic-Equipment nötig.',
    },
    enemies: {
      swarmling: 'Swarmling',
      security_bot_mk1: 'Security-Bot MK1',
      glitch_drone: 'Glitch-Drohne',
      patrol_drone: 'Patrol-Drohne',
      reaver_bot: 'Reaver-Bot',
      elite_sentinel: 'Elite-Wächter',
      void_stalker: 'Void-Stalker',
      bunker_warden: 'Bunker-Warden',
      reactor_titan: 'Reaktor-Titan',
      nexus_apex: 'Nexus-Apex',
      omega_herald: 'Omega-Herold',
    },
  },
  character: {
    headline: 'Runner-Charakter',
    stats: 'Kampfwerte',
    attack: 'Angriff',
    defense: 'Verteidigung',
    hp: 'HP',
    equipment: 'Ausrüstung',
    slots: {
      weapon: 'Waffe',
      helmet: 'Helm',
      armor: 'Rüstung',
      accessory: 'Accessoire',
      shield: 'Schild',
      belt: 'Gürtel',
      sash: 'Schärpe',
      shoulder: 'Schultern',
    },
    equip: 'Anlegen',
    unequip: 'Ablegen',
    empty: 'Leer',
    chooseItem: 'Item auswählen',
    noItems: 'Keine passenden Items im Inventar.',
    delete: 'Runner löschen',
    deleteConfirm: 'Runner wirklich löschen? Alle Fortschritte gehen verloren.',
    memberSince: 'Mitglied seit',
    class: 'Klasse',
    freelancer: 'Freelancer',
    upgrade: 'Upgraden',
    upgradeTo: 'auf +{level}',
    maxLevel: 'Max-Level erreicht',
    nextLevel: 'Nächstes Level',
    cost: 'Kosten',
    statPreview: 'Stats nach Upgrade',
  },
  upgrade: {
    title: 'Equipment verbessern',
    currentLevel: 'Aktuell',
    insufficient: 'Ressourcen fehlen',
    confirm: 'Upgraden',
    cancel: 'Abbrechen',
  },
  boosts: {
    combat_stim: 'Kampf-Stim',
    combat_stim_desc: '+25% Schaden für 5 Minuten',
    shield_matrix: 'Schild-Matrix',
    shield_matrix_desc: '+30% Verteidigung für 5 Minuten',
    nano_medkit: 'Nano-Medkit',
    nano_medkit_desc: 'Voll-Heal (instant)',
    lucky_scan: 'Glücks-Scan',
    lucky_scan_desc: '+50% Loot-Chance für 10 Minuten',
  },
  miners: {
    basic_clicker: 'Basis-Clicker',
    basic_clicker_desc: '+1 Credit / Sek',
    scrap_hound: 'Scrap-Sammler',
    scrap_hound_desc: '+1 Scrap alle 3 Sek',
    chip_miner: 'Chip-Miner',
    chip_miner_desc: '+1 Nano-Chip alle 10 Sek',
    data_harvester: 'Data-Harvester',
    data_harvester_desc: '+1 Data-Track alle 30 Sek',
    quantum_rig: 'Quantum-Rig',
    quantum_rig_desc: '+1 Hyper-Prozessor alle 2 Min',
  },
  skillWeb: {
    headline: 'Skill-Web',
    sub: 'Radialer Talent-Tree — Core → Synergie → Capstone',
    coreRing: 'Kern-Knoten',
    synergyRing: 'Synergie-Knoten',
    capstoneRing: 'Capstone (Combat-Skills)',
    locked: 'Voraussetzungen fehlen',
    maxed: '✓ Maximal-Level',
    research: 'Erforschen',
    nodes: {
      vitality: 'Vitalität',
      vitality_desc: '+5 % MaxHP pro Level',
      alloy: 'Legierung',
      alloy_desc: '+5 % DEF pro Level',
      aggression: 'Aggression',
      aggression_desc: '+5 % ATK pro Level',
      data_vampirism: 'Daten-Vampirismus',
      data_vampirism_desc: 'Heilt beim Raum-Wechsel 1 % MaxHP pro Lv pro 100 CD im Run (Cap 25 %)',
      extra_boss_roll: 'Schatzjäger',
      extra_boss_roll_desc: '+1 Boss-Loot-Roll pro Level',
      kinetic_stack: 'Kinetik-Absorber',
      kinetic_stack_desc: '+1 DEF-Stack pro Treffer (max 50)',
      salvage_yield: 'Salvage-Experte',
      salvage_yield_desc: '60 → 100 % Rückerstattung beim Zerlegen',
      thermodynamics: 'Thermodynamik',
      thermodynamics_desc: '+25 Max-Heat & +5 % Siphon-Damage pro Level',
      compound_processor: 'Zinseszins-Prozessor',
      compound_processor_desc: '+1 % ATK pro 10 k unverarbeitetem CD im Buffer (max +50 %)',
      cap_execute: 'Execute',
      cap_execute_desc: 'Tötet Gegner unter X % HP sofort (Capstone)',
      cap_momentum: 'Momentum',
      cap_momentum_desc: '+X % Special-Charge pro Kill (Capstone)',
      cap_shield_bash: 'Shield Bash',
      cap_shield_bash_desc: 'Special: DEF × Multiplier statt ATK (Capstone)',
      cap_market_manip: 'Market Manipulation',
      cap_market_manip_desc: 'Decrypter-Speed-Boost für 60 s (Capstone)',
      cap_fireball: 'Fireball',
      cap_fireball_desc: 'Projektil, ignoriert 50 % DEF (Capstone)',
      cap_lightning_bolt: 'Lightning Bolt',
      cap_lightning_bolt_desc: 'Instant, kein Counter-Damage (Capstone)',
      cap_frost_lance: 'Frost Lance',
      cap_frost_lance_desc: 'Friert kurz ein (Capstone)',
    },
  },
  decrypters: {
    headline: 'Decrypter-Netzwerk',
    sub: 'Verarbeitet Corrupted Data zu Clean Code',
    feedAll: 'Alle füttern',
    bufferEmpty: 'Buffer leer — füttere CD',
    bufferFull: 'Buffer voll — Speicher erweitern',
    speed: 'Speed',
    storage: 'Speicher',
    output: 'Ertrag',
    perMin: '/min',
    per100: 'pro 100 CD',
    nanoChipChance: 'Nano-Chip-Chance',
    doubleStorage: 'Speicher ×2 (50 ◇)',
    locked: 'Lv {level} benötigt',
    scrap_parser: 'Scrap-Parser',
    scrap_parser_desc: 'Tier 1 — Basis-Konverter, kostenlos',
    chip_extractor: 'Chip-Extractor',
    chip_extractor_desc: 'Tier 2 — schneller, 5 % Nano-Chip-Drop',
    quantum_node: 'Quantum-Node',
    quantum_node_desc: 'Tier 3 — Endgame, 10 % Doppel-Chip-Drop',
  },
  resources: {
    credits: 'Credits',
    premium: 'Quantum',
    cleanCode: 'Clean Code',
    corruptedData: 'Corrupted Data',
    neonGems: 'Neon Gems',
    scrap: 'Scrap',
    energy_cell: 'Energie-Zelle',
    nano_chip: 'Nano-Chip',
    data_track: 'Data-Track',
    hyper_processor_5: 'Hyper-Prozessor',
  },
  items: {
    // ── Resources ──────────────────────────────────────────────
    hyper_processor_5: 'Hyper-Prozessor',
    energy_cell: 'Energie-Zelle',
    data_track: 'Daten-Track',
    nano_chip: 'Nano-Chip',
    scrap: 'Schrott',
    // ── Starter-Kit (common, brand-new character only) ─────────
    starter_blade: 'Übungs-Klinge',
    starter_jacket: 'Recyceltes Wams',
    starter_helmet: 'Streuner-Helm',
    // ── Hollow-Knight Set (legendary, sole equipment set) ──────
    hk_armor: 'Leere Rüstung',
    hk_mask: 'Hohle Maske',
    hk_cloak: 'Schatten-Mantel',
    hk_scarf: 'Void-Wickel',
    hk_drape: 'Schatten-Schweif',
    hk_heart: 'Seelen-Herz',
    hk_nail: 'Hohler Nagel',
    hk_shield: 'Seelen-Schild',
    // ── Vault-Knight Set (P3 — Stormcaller-Affinity, storm/lightning theme) ──
    vk_armor: 'Sturmpanzer',
    vk_helm: 'Voltage-Helm',
    vk_pauldrons: 'Donner-Pauldrons',
    vk_sash: 'Tempest-Schärpe',
    vk_belt: 'Static-Gürtel',
    vk_relic: 'Sturm-Relikt',
    vk_blade: 'Sturmrufer-Klinge',
    vk_buckler: 'Aegis-Buckler',
    // ── Legendary (boss-exclusive) ─────────────────────────────
    legendary_sword: 'Singularitäts-Klinge',
    legendary_staff: 'Arkanstab',
    legendary_lightning: 'Zeus-Blitz',
    legendary_amulet: 'Wächter-Amulett',
  },
  skills: {
    execute: 'Execute',
    execute_desc: 'Tötet Gegner unter {pct}% HP sofort. Bei Bossen halbiert.',
    momentum: 'Momentum',
    momentum_desc: 'Jeder Kill lädt den Spezialangriff um {pct}% auf.',
    shield_bash: 'Schild-Ramme',
    shield_bash_desc: 'Spezialangriff verursacht {mult}× DEF als Schaden. CD: 8 Ticks.',
    kinetic_absorption: 'Kinetische Absorption',
    kinetic_absorption_desc: 'Erlittene Treffer gewähren +{n} DEF für diesen Run (max 50).',
    market_manipulation: 'Markt-Manipulation',
    market_manipulation_desc: 'Aktiviert {mult}× Miner-Ertrag für 60 Sekunden.',
    compounding_interest: 'Zinseszins',
    compounding_interest_desc: '+1% Einkommen pro {k} Credits auf dem Konto (max +50%).',
    treasure_hunter: 'Schatzjäger',
    treasure_hunter_desc: 'Boss-Loot wird {n}× gerollt statt 1×.',
    salvage_expert: 'Verwertungs-Experte',
    salvage_expert_desc: 'Salvage gibt {pct}% der Ressourcen zurück.',
    fireball: 'Feuerball',
    fireball_desc: 'Feuert einen Feuerball: {mult}× Schaden, ignoriert 50% DEF.',
    lightning_bolt: 'Blitzschlag',
    lightning_bolt_desc: 'Sofortiger Blitzschlag: {mult}× Schaden, kein Konter.',
    frost_lance: 'Eislanze',
    frost_lance_desc: 'Eislanzen-Wurf: {mult}× Schaden, gefriert den Gegner kurz.',
    frost_nova: 'Frost-Nova',
    frost_nova_desc: 'AOE-Frost-Welle: {mult}× ATK, +30% DEF für 5s, Slow auf Gegner.',
    phantom_burst: 'Phantom-Stoß',
    phantom_burst_desc: 'Phantom-Stoß: {mult}× Schaden mit garantiertem Crit, trifft bis zu 4 Nahe.',
    engineer_overload: 'Überladung',
    engineer_overload_desc: 'Überladung: {mult}× Schaden, ignoriert 60% Verteidigung.',
    activeSkill: 'Aktiver Skill',
    passiveSkill: 'Passiver Skill',
    noSkill: 'Kein Skill',
    locked: 'Freischaltbar ab Vault-Tier {tier}',
    activate: 'Aktivieren',
  },
  sets: {
    phantom_strike: 'Phantom-Schlag',
    titans_shell: 'Titanen-Panzer',
    scrap_baron: 'Schrott-Baron',
    probability_matrix: 'Wahrscheinlichkeits-Matrix',
    pieces: '{n}/4 Teile',
    bonus_2pc: '2-Teile-Bonus',
    bonus_4pc: '4-Teile-Bonus',
  },
  ascension: {
    title: '✦ Aufsteigen zu Legendär',
    button: 'Aufsteigen',
    notAffordable: 'Ressourcen fehlen',
    ascendedLabel: 'Aufgestiegen · Legendär',
    requirement: 'Nur für Set-Items auf +10',
  },
  leaderboard: {
    headline: '🏆 Rangliste',
    categoryItemPower: 'Item Power',
    categoryLevel: 'Level',
    categoryVault: 'Vault Tier',
    categoryCredits: 'Credits',
    categoryEndless: 'Endless',
    you: '← Du',
    outsideTop: 'Du bist auf Rang {rank}',
    refresh: 'Aktualisieren',
    loading: 'Lade Rangliste …',
    empty: 'Noch keine Einträge vorhanden.',
    error: 'Fehler beim Laden der Rangliste.',
  },
  legendaryEffects: {
    armor_penetration: '⚔ Rüstungsdurchdringung: Ignoriert gegnerische DEF vollständig. +35% erlittener Schaden.',
    death_prevention: '💀 Todesschutz: Verhindert den Tod einmal pro Run (heilt 50% HP).',
    credits_to_atk: '◈ Reichtums-ATK: +1 ATK pro 500.000 Credits auf dem Konto (max +200).',
    gambler_fallacy: '🎲 Spielertrugschluss: +0.2% Legendary-Chance pro Treffer ohne Legendary-Drop.',
    arcane_focus: '🔮 Arkaner Fokus: +50% Schaden auf den ersten Treffer eines frischen Gegners (volle HP).',
    chain_lightning: '⚡ Kettenblitz: 30% Chance, einen weiteren Gegner mit 60% Schaden zu treffen.',
  },
  boss: {
    alpha: 'Rogue Warden',
    sigma: 'Iron Reaver',
    tau: 'Void Sentinel',
    phi: 'Titan Core',
    omega: 'Omega Herald Prime',
  },
  research: {
    combat_overdrive: 'Combat Overdrive',
    combat_overdrive_desc: 'Erhöht permanenten Angriff.',
    neural_shield: 'Neuralschild',
    neural_shield_desc: 'Erhöht permanente Verteidigung.',
    bio_enhancement: 'Bio-Enhancement',
    bio_enhancement_desc: 'Erhöht permanente maximale HP.',
    data_compression: 'Datenkompression',
    data_compression_desc: 'Erhöht dauerhaft XP-Gewinn.',
    credit_siphon: 'Credit-Siphon',
    credit_siphon_desc: 'Erhöht Credits pro Terminal-Klick.',
    quantum_harvest: 'Quantum-Ernte',
    quantum_harvest_desc: 'Erhöht Loot-Drop-Chance.',
  },
} as const;

export type I18n = typeof de;

export function itemName(nameKey: string): string {
  const table = de.items as Record<string, string>;
  return table[nameKey] ?? nameKey;
}

export function rarityLabel(rarity: keyof typeof de.inventory.rarity): string {
  return de.inventory.rarity[rarity];
}

export function enemyName(id: string): string {
  const table = de.dungeon.enemies as Record<string, string>;
  return table[id] ?? id;
}

export function vaultName(id: string): string {
  const table = de.dungeon.vaults as Record<string, string>;
  return table[id] ?? id;
}

export function vaultDesc(id: string): string {
  const descKey = `${id}_desc` as keyof typeof de.dungeon.vaults;
  const table = de.dungeon.vaults as Record<string, string>;
  return table[descKey] ?? '';
}

export function resourceLabel(id: string): string {
  const table = de.resources as Record<string, string>;
  return table[id] ?? id;
}

export function minerName(id: string): string {
  const table = de.miners as Record<string, string>;
  return table[id] ?? id;
}

export function minerDesc(id: string): string {
  const key = `${id}_desc`;
  const table = de.miners as Record<string, string>;
  return table[key] ?? '';
}

export function boostName(id: string): string {
  const table = de.boosts as Record<string, string>;
  return table[id] ?? id;
}

export function boostDesc(id: string): string {
  const key = `${id}_desc`;
  const table = de.boosts as Record<string, string>;
  return table[key] ?? '';
}
